import { axios } from '@/utils/request'


//post
export function postAction(url,parameter) {
    return axios({
        url: url,
        method:'post' ,
        data: parameter
    })
}

export function postActionTimeout(url,parameter,timeout) {
    return axios({
        url: url,
        method:'post' ,
        data: parameter,
        timeout:timeout
    })
}


//post method= {post | put}
export function httpAction(url,parameter,method) {
    return axios({
        url: url,
        method:method ,
        data: parameter
    })
}

export function httpActionTimeout(url,parameter,method,timeout) {
    return axios({
        url: url,
        method:method ,
        data: parameter,
        timeout:timeout
    })
}

//put
export function putAction(url,parameter) {
    return axios({
        url: url,
        method:'put',
        data: parameter
    })
}

//get
export function getAction(url,parameter) {
    return axios({
        url: url,
        method: 'get',
        params: parameter
    })
}

export function getActionTimeout(url,parameter,timeout) {
    return axios({
        url: url,
        method: 'get',
        params: parameter,
        timeout:timeout
    })
}

//deleteAction
export function deleteAction(url,parameter) {
    return axios({
        url: url,
        method: 'delete',
        params: parameter
    })
}

export function downFile(url,parameter){
    return axios({
        url: url,
        params: parameter,
        method:'get' ,
        responseType: 'blob',
        timeout: 90000,
    })
}
